// Tiny shared UI helpers.

// Escape the HTML-significant chars before interpolating user/text content into
// template strings. Matches the per-file copies this replaced exactly.
export function esc(s: string): string {
  return s.replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]!));
}

// Format a minute count as m:ss (e.g. 12.5 → "12:30"). Used by the scoring tables.
export function fmtMin(min: number): string {
  const s = Math.round(min * 60);
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}
